import { ReactNode, lazy, Suspense } from "react";
import { queryString } from "capitalrx-utilities";

import { ThemeSelectorContext } from "./ThemeSelectorContext";

import { ALLOW_CLIENT_LIST } from "@/basic/constants/allowClientList";

const Caprx = lazy(async () => await import("@/basic/themes/Caprx"));
const Cdphp = lazy(async () => await import("@/basic/themes/Cdphp"));

interface ThemeSelectorProps {
  children: ReactNode;
}

export const ThemeSelector = ({ children }: ThemeSelectorProps) => {
  const search = window.location.search;
  const { client } = queryString.getQueryParams(search);

  let clientName = undefined;

  // CapRx theme is the main theme
  let theme = <Caprx />;

  // Make sure client name is not undefined
  if (client && ALLOW_CLIENT_LIST.includes(client?.toString())) {
    clientName = client?.toString();

    if (client === "cdphp") {
      theme = <Cdphp />;
    }
  }

  return (
    <ThemeSelectorContext.Provider value={{ client: clientName }}>
      <Suspense fallback={null}>{theme}</Suspense>
      {children}
    </ThemeSelectorContext.Provider>
  );
};
